import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { VALUATION_METHODS } from '../../constants';
import { valuationMethodDescriptionSx } from '../../styles';

interface ValuationMethodDescriptionProps {
  currentValue: string;
}

export default function ValuationMethodDescription({ currentValue }: ValuationMethodDescriptionProps) {
  const { t } = useTranslation();

  return (
    <Typography variant='body2' color='textSecondary' sx={valuationMethodDescriptionSx}>
      {currentValue === VALUATION_METHODS.CURRENT_CASE_COST && (
        <>
          {t('inventory.inventoryValuationSettings.valuationMethods.currentCaseCost')}:{' '}
          {t('inventory.inventoryValuationSettings.currentCaseCostDescription')}
        </>
      )}
      {currentValue === VALUATION_METHODS.DAILY_WEIGHTED_AVERAGE && (
        <>
          {t('inventory.inventoryValuationSettings.valuationMethods.dailyWeightedAverage')}:{' '}
          {t('inventory.inventoryValuationSettings.dailyWeightedAverageDescription')}
        </>
      )}
      {currentValue === VALUATION_METHODS.MONTHLY_WEIGHTED_AVERAGE && (
        <>
          {t('inventory.inventoryValuationSettings.valuationMethods.monthlyWeightedAverage')}:{' '}
          {t('inventory.inventoryValuationSettings.monthlyWeightedAverageDescription')}
        </>
      )}
    </Typography>
  );
}
